@if (isLoading) {
  <div class="loading-container" [attr.data-loading-key]="loadingKey">
    <atlas-summary-stats-loading
      [libraryId]="currentLibraryId"
      (loadingComplete)="onLoadingComplete()"
      (loadingError)="onLoadingError()">
    </atlas-summary-stats-loading>
  </div>
} @else {
  <dx-data-grid
    class="standard-grid"
    keyExpr="shape_id"
    atlasDxDataGridDefaultOptions
    [dataSource]="dataSource"
    [selection]="{ mode: 'single' }"
    [focusedRowEnabled]="true"
    [autoNavigateToFocusedRow]="true"
    [remoteOperations]="{ filtering: true, sorting: true, paging: true }"
    [columnAutoWidth]="false"
    columnResizingMode="widget"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onInitialized)="onInitialized($event)"
    (onContentReady)="onContentReady($event)"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-paging [pageSize]="50"></dxo-paging>

    <dxo-scrolling
      mode="virtual"
      rowRenderingMode="virtual"
      useNative="false"
    ></dxo-scrolling>

    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="false"></dxo-search-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-column-chooser
      [enabled]="true"
      [mode]="'select'"
      [allowSearch]="true"
    ></dxo-column-chooser>

    <atlas-dx-grid-header></atlas-dx-grid-header>
    <dxi-column
      *ngFor="let column of columns"
      [dataField]="column.dataField"
      [caption]="column.caption"
      [dataType]="column.dataType"
      [format]="column.format"
      [allowSorting]="column.allowSorting"
      [allowFiltering]="column.allowFiltering"
      [allowHiding]="column.allowHiding"
      [allowResizing]="true"
      [width]="column.width"
    ></dxi-column>

    <dxo-state-storing
      [enabled]="true"
      type="custom"
      [customSave]="customSaveState"
      [customLoad]="customLoadState"
    ></dxo-state-storing>
  </dx-data-grid>
}
